import { render } from "./PerformanceMarketingStartBox.vue?vue&type=template&id=8488e730"
import script from "./PerformanceMarketingStartBox.vue?vue&type=script&lang=js"
export * from "./PerformanceMarketingStartBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__